import React from 'react';
import { Link } from 'react-router';
import clone from 'ramda/es/clone';
import path from 'ramda/es/path';

import api from 'app/actions/api';
import { popup } from 'app/common/actions/popup';
import { Trans } from 'react-i18next';
import i18n from 'app/i18n';
import { getSignByCode } from 'app/common/components-next/currency';


/**
/* Подписка на приложение
*/

export const SUB_PAY_REQUEST = 'SUB_PAY_REQUEST';
export const SUB_PAY_SUCCESS = 'SUB_PAY_SUCCESS';
export const SUB_PAY_FAILURE = 'SUB_PAY_FAILURE';
export const SUB_RESET_NOT_ENOUGH = 'SUB_RESET_NOT_ENOUGH';

const subPayRequest = () => ({
  type: SUB_PAY_REQUEST,
});

const subPaySuccess = data => ({
  type: SUB_PAY_SUCCESS,
  payload: data,
});

const subPayFailure = payload => ({
  type: SUB_PAY_FAILURE,
  payload,
});

export const subResetNotEnough = () => ({
  type: SUB_RESET_NOT_ENOUGH,
});


export const subPay = (subId, informer) => async (dispatch, getState) => {
  const { country_iso_code: code } = getState().dealer;

  const postData = {
    id: subId,
  };
  if (informer) {
    postData.informer = informer;
  }
  dispatch(subPayRequest());
  try {
    const { data } = await api('cabinet/subscriptions/pay', 'post', { data: postData });
    if (data.result) {
      delete data.result;
    }
    dispatch(subPaySuccess({ subs: data }));
    dispatch(popup(i18n.t('app:request_pay_success')));
  } catch (error) {
    const errCode = path(['response', 'status'], error);
    const amount = path(['response', 'data', 'amount'], error);

    if (errCode === 403) {
      const amountCurrency = `${amount}${getSignByCode(code)}`;

      dispatch(subPayFailure({
        error: clone(error),
        err: <span>
          <Trans
            i18nKey="app:request_not_enough_funds"
            values={{ amount: amountCurrency }}
          >
            {'Недостаточно {{amount}} на счету. '}
            <Link to={`/finances/fund/refill/self/primary/step2?amount=${amount}`}>
              {'Пополнить'}
            </Link>
          </Trans>
        </span>,
        errCode,
      }));
      return;
    }
    dispatch(subPayFailure({ err: i18n.t('app:request_pay_failed'), errCode }));
  }
};
